import { Column, CopyRightSection, Input, LanguageSection, LanguageWide, MailSection, Title, Wrapper, CustomLink } from "./styles";
import { ABOUT_US, FOR_HOSTS, FOR_STUDENTS, LEGAL, SUPPORT } from "./constants";
import { Button, StyledButton, TextPlain, TitleH2 } from "../generic";
import { useWindowSize } from "../../utils/hooks/useWindowSize";
import React, { useEffect, useState } from "react";
import { Facebook, Instagram, Tiktok } from "../Icons/SocialIcons";
import { useTranslation } from "react-i18next";
import Select, { useSelect } from "../Select";
import { IPropsFC } from "../../interfaces/intarfaces";
import Modal from "../Modal";
import { DialogWrapper } from "../containers";
import { useContextHospi } from "../../context/ContextHospi";
import { SmallLoader } from "../SmallLoader";
import { NavLink, useLocation, useNavigate, Link } from "react-router-dom";

export const Footer = () => {
    const [width] = useWindowSize();
    const { t, i18n } = useTranslation(['footer', 'contact'])
    const { setFromFooter } = useContextHospi();
    const navigate = useNavigate()
    const location = useLocation()
    const changeLanguage = (flag: string): void => {
        navigate({ pathname: `/${flag.toLowerCase()}/${location.pathname.slice(4)}` }, { replace: true })
        i18n.changeLanguage(flag.toLocaleLowerCase());
    };

    const LANGUAGES_SELECT = [
        {
            label: t('footer.gb'),
            value: 'gb'
        },
        {
            label: t('footer.nl'),
            value: 'nl'
        }
    ];

    const [showModal, setShowModal] = useState<number>(0);
    const [email, setEmail] = useState<string>('')
    const [emailError, setEmailError] = useState<string>('')
    const [loading, setLoading] = useState<boolean>(false)

    const language = {
        ...useSelect(i18n.language || undefined, true),
    };

    function isValidEmail(email: string) {
        return /\S+@\S+\.\S+/.test(email);
    }

    useEffect(() => {
        setEmailError((!isValidEmail(email) && email) ? 'formSection.errors.invalidEmail' : '')
    }, [email])

    const sendData = () => {
        if (email.trim() && !emailError) {
            setLoading(true)
            const requestOptions = {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    type: "newsletter",
                    browser_language: i18n.language,
                } as any),
            };

            fetch(
                process.env.REACT_APP_AWS_ENDPOINT! +
                `contact-us/${email.trim() as string}`,
                requestOptions
            )
                .then((response) => response.json())
                .then((data) => setShowModal(1))
                .then(() => setLoading(false))
            setEmail('')
        } else {
            setEmailError('Required field')
        }
    };

    const [helpState, setHelpState] = useState('')

    useEffect(() => {
        helpState && changeLanguage(helpState)
    }, [helpState])

    const titlePholder = (part: string, variable: string): IPropsFC => {
        return {
            title: 'test',
            placeholder: 'placeholder',
            w: "initial",
            grow: "1",
        };
    };

    const renderList = (list: { title: string, link: string }[]) => {
        return <ul>
            {
                list.map(({ link, title }) => (
                    <li key={title} onClick={() => setFromFooter(true)}>
                        <NavLink to={`/${i18n.language}${link}?f=f`}>{t(`footer.${title}`)}</NavLink>
                    </li>
                ))
            }
        </ul>
    }

    return (
        <>
            <Wrapper>
                <div>
                    <Column>
                        <div>
                            <Title>
                                {t('footer.aboutUs')}
                            </Title>
                            {renderList(ABOUT_US)}
                        </div>
                        <div>
                            <div>
                                <Title>
                                    {t('footer.forHosts')}
                                </Title>
                                {renderList(FOR_HOSTS)}
                            </div>
                            <div style={{ marginTop: 64 }}>
                                <Title>
                                    {t('footer.forStudents')}
                                </Title>
                                {renderList(FOR_STUDENTS)}
                            </div>
                        </div>
                    </Column>
                    <Column>
                        <div>
                            <Title>
                                {t('footer.support')}
                            </Title>
                            {renderList(SUPPORT)}
                        </div>
                        <div>
                            <div style={{ marginTop: width <= 768 ? 42 : 0 }}>
                                <Title>
                                    {t('footer.legal')}
                                </Title>
                                {renderList(LEGAL)}
                                <CustomLink href="https://hospihousing-documents.s3.eu-west-1.amazonaws.com/Hospi+Housing+general+terms+and+conditions.pdf
" target="_blank" rel="noreferrer">{t('footer.teamConditions')}</CustomLink>
                            </div>
                            {
                                width > 425 && <LanguageSection style={{ marginTop: 40 }}>

                                    <Title>
                                        {t('footer.language')}
                                    </Title>
                                    <Select
                                        handleClick={setHelpState}
                                        {...language}
                                        {...titlePholder("personalDetails", "countryCode")}
                                        items={LANGUAGES_SELECT}
                                        id="language"
                                    />
                                </LanguageSection>
                            }
                        </div>
                    </Column>
                </div>
                {
                    width <= 425 && <LanguageWide>
                        <Title>
                            {t('footer.language')}
                        </Title>
                        <Select
                            handleClick={setHelpState}
                            {...language}
                            {...titlePholder("personalDetails", "countryCode")}
                            items={LANGUAGES_SELECT}
                            id="language"
                        />
                    </LanguageWide>
                }
                <MailSection>
                    <div>
                        <Title>
                            {t('footer.signUpEmail')}
                        </Title>
                        <p>
                            {t('footer.latestNews')}
                        </p>
                    </div>
                    <div style={{ display: 'flex' }}>
                        <Input
                            name='email'
                            error={!!emailError}
                            onChange={(e) => setEmail(e.target.value)}
                            value={email}
                            placeholder={t('contact.form.email', { ns: 'contact' }).slice(0, t('contact.form.email', { ns: 'contact' }).length - 1)}
                        />
                        <StyledButton p='9px 17px' disabled={loading} onClick={sendData}>
                            {loading ? (
                                <SmallLoader minWidth={70} height={18} borderWidth={2} color='white' />
                            ) : (
                                t('footer.signUp')
                            )}
                        </StyledButton>
                    </div>
                </MailSection>
                <CopyRightSection>
                    <span>
                        {t('footer.copyRight')}
                    </span>
                    <span id='kvk'>
                        KvK 74539787
                    </span>
                    <div>
                        <a href="https://www.facebook.com/Hospihousing" target='_blank'>{Facebook}</a>
                        <a href="https://www.instagram.com/hospihousing/" target='_blank'>{Instagram}</a>
                        <a href="https://www.tiktok.com/@hospihousing" target='_blank'>{Tiktok}</a>
                    </div>
                </CopyRightSection>
            </Wrapper>
            {(
                <Modal isShow={!!showModal} handleClose={() => setShowModal(0)}>
                    <DialogWrapper>
                        <TitleH2
                            style={{
                                textAlign: "left",
                            }}
                        >
                            {t(`contact.email.title`, { ns: 'contact' })}
                        </TitleH2>
                        <TextPlain
                            style={{
                                whiteSpace: "pre-line",
                                wordBreak: "break-word",
                                textAlign: "left",
                            }}
                        >
                            {t(`contact.email.textSubscribe`, { ns: 'contact' })}
                        </TextPlain>
                        <div className="buttons">
                            <span />
                            <Button main onClick={() => setShowModal(0)}>
                                {t(`contact.closeBox`, { ns: 'contact' })}
                            </Button>
                        </div>
                    </DialogWrapper>
                </Modal>
            )
            }
        </>
    )
}
